import { $isElementNode, LexicalNode } from 'lexical';

export function traverse(node: LexicalNode, cb: (node: LexicalNode) => void) {
  cb(node);
  if ($isElementNode(node)) {
    node.getChildren().forEach((child) => traverse(child, cb));
  }
}
